import BarSoftButton from 'components/_NewComponents/BarSoftButton';

function ButtonListModfierSelector({getSelectedCount, group, decreaseCount, increaseCount, handelClickOnModifier}) {
	return (
		<div className='w-full flex flex-row gap-2 flex-wrap justify-center'>
			{group.modifiers
				?.filter((modifier) => modifier?.availability?.visible === 1)
				?.map((modifier) => {
					return (
						<BarSoftButton
							forceCustom={true}
							fullWidth={false}
							size='md'
							onPress={() => {
								if (modifier?.count < 1) {
									increaseCount({
										modifierUUID: modifier.uuid,
										count: modifier.count,
										min: modifier.min,
										max: modifier.max,
									});
								} else {
									decreaseCount({
										modifierUUID: modifier.uuid,
										count: modifier.count,
										min: modifier.min,
										max: modifier.max,
									});
								}
							}}
							color='secondary'
							className={`${modifier?.count < 1 ? 'opacity-50' : ''} font-bold`}
							key={modifier.uuid}>
							{modifier?.name?.hu}
						</BarSoftButton>
					);
				})}
		</div>
	);
}

export default ButtonListModfierSelector;
